__turbopack_context__.v({
  "info": "helper-block-module-scss-module__cyUQVa__info",
  "info__button": "helper-block-module-scss-module__cyUQVa__info__button",
  "info__secondaryText": "helper-block-module-scss-module__cyUQVa__info__secondaryText",
  "root": "helper-block-module-scss-module__cyUQVa__root",
  "text": "helper-block-module-scss-module__cyUQVa__text",
});
